import { createFileRoute } from "@tanstack/react-router";
import { OnboardingLayout } from "@/features/onboarding/onboarding-layout";

export const Route = createFileRoute("/onboarding")({
  component: OnboardingLayout,
});
